import React, { useState } from 'react';
import SellerHeader from '../../components/SellerHeader';
import ShopDetailsForm from '../../components/ShopDetailsForm';

const AddShopForm = () => {

  return (
    <>
      <SellerHeader />
      <ShopDetailsForm />
    </>
  );
};

export default AddShopForm;
